import type { CategoryWithChannels } from '@setplex/tria-api'
import type { TFunction } from '~/core/i18n'
import type { AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import type { UiCategoryWithChannels } from '~/shared/interfaces'

import { extendMediaItemByLabelPriceTvChannel } from '~/shared/tools'

export const formatCategoryWithChannelsToUi = (
  data: CategoryWithChannels | null,
  adjust: AdjustPurchaseableFn,
  t: TFunction
): UiCategoryWithChannels | null => {
  if (!data) return null

  const formattedContent = data.content.map((channel) =>
    extendMediaItemByLabelPriceTvChannel(adjust(channel))
  )

  const name = data.id === 0 ? t('all') : data.name

  return {
    ...data,
    name,
    content: formattedContent,
  }
}
